import { create } from "zustand";
import { useFetchBrickWorkingReportSlice } from "../slices/BrickWorkingReportsSlices/fetchBrickWorkingReportSlice";

interface FetchBrickWorkingReportInterface
  extends ReturnType<typeof useFetchBrickWorkingReportSlice> {}

export const BrickWorkingReportsStore = create<FetchBrickWorkingReportInterface>(
  (...a) => ({
    ...useFetchBrickWorkingReportSlice(...a),
  })
);
